export default {"src":"/_next/static/media/spinner.4cd2f563.gif","height":221,"width":221};